import {
  comboLabel,
  PDV_SHORTCUT_ACTIONS,
  PDV_SHORTCUT_META,
  type PdvShortcutAction,
} from "@vertex/validators/pdv-pure";
import { Kbd } from "@vertex/ui/primitives/kbd";
import { useShortcutRegistry } from "./registry";

/**
 * Rodapé permanente. São 6 atalhos e ~40 linhas, e respondem por 90% da
 * descoberta: operador de balcão não abre tela de ajuda, ele olha pra baixo.
 * O overlay do F1 existe pro resto.
 *
 * Mostra o combo REAL (resolvido do registry), não "F3" cravado no código —
 * uma org que remapeou veria a tecla errada, que é pior do que não mostrar.
 */
export function ShortcutsBar() {
  const { combos } = useShortcutRegistry();
  const visiveis = PDV_SHORTCUT_ACTIONS.filter(
    (a) => PDV_SHORTCUT_META[a].footer && combos(a).length > 0,
  );

  if (visiveis.length === 0) return null;

  return (
    <footer
      className="flex items-center gap-4 overflow-x-auto px-4 py-2"
      style={{ borderTop: "1px solid var(--line)", background: "var(--footer-bg)" }}
    >
      {visiveis.map((a) => (
        <Atalho key={a} action={a} combo={combos(a)[0]!} />
      ))}
    </footer>
  );
}

function Atalho({ action, combo }: { action: PdvShortcutAction; combo: string }) {
  return (
    <span className="flex shrink-0 items-center gap-1.5" style={{ fontSize: "var(--fs-caption)" }}>
      <Kbd>{comboLabel(combo).join(" + ")}</Kbd>
      <span style={{ color: "var(--ink-3)" }}>{PDV_SHORTCUT_META[action].label}</span>
    </span>
  );
}
